import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Clipboard } from "@faire/web/slate/icons/foundation/Clipboard";
import React from "react";
export var useMyCatalogBrandNodes = function useMyCatalogBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    MyCatalog: {
      id: "MyCatalog",
      label: strictLocalize({
        id: "FjWrdn",
        defaultMessage: [{
          "type": 0,
          "value": "Product catalogue"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Clipboard, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      articles: [articles.ManageMyShop.CUSTOMIZE_MY_PRODUCT_TRANSLATIONS, articles.ManageMyShop.CURRENCY_SPECIFIC_PRICING, articles.ManageMyShop.SETTING_PRODUCT_INVENTORY_LEVELS, articles.ManageMyShop.ARRANGE_MY_SHOP_LISTINGS],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "BRiEk3",
        defaultMessage: [{
          "type": 0,
          "value": "Catalogue issue"
        }]
      })
    }
  };
};